import styled from 'styled-components';
import BlockButton from '@sdk/components/ui/buttons/BlockButton';

export const StyledBlockButton = styled(BlockButton)`
  min-width: 140px;
`;
